// extracted by mini-css-extract-plugin
export default {"modal":"AuthDialog_modal__WG78e","wrapper":"AuthDialog_wrapper__iBfLW"};